<template>
  <div class="modal-footer">
    <!-- promo_code -->
    <div class="promo-block" v-show="!(step === '2' && errorMessage)">
      <validation-observer
        v-show="settings.has_coupons && step === '1'"
        v-slot="{ invalid, valid, errors, ...rest }"
        ref="couponForm"
      >
        <form class="coupon-form" @submit.prevent="onHandleAddCoupon">
          <validation-provider vid="code" v-slot="{errors}">
            <div class="promo-wrapper">
              <input
                id="coupon_code"
                class="form-control w140 promo-code-input"
                type="text"
                name="code"
                v-model="code"
                :placeholder="conference.organization_id === 3526 ? 'Promo Code' : 'Coupon Code'"
              />

              <button
                type="button"
                class="btn btn-secondary  w140"
                :disabled="showIndicator"
                @click="onHandleAddCoupon"
              >Activate Code</button>
            </div>
            <div class="promo-code-error text-danger" v-if="errors && errors[0]">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </form>
      </validation-observer>

      <!-- isAttendee -->
      <div class="copy-to-attendee" v-show="step === '1.1'">
        <event-checkbox
          label="I am registering as part of the group"
          v-model="isAttendee"
        ></event-checkbox>
      </div>
    </div>

    <div v-show="step === '2' && errorMessage" class="text-danger">
      <strong>Please complete all required fields before clicking Submit</strong>
    </div>

    <!-- button Next -->
    <button
      v-show="showNextButton"
      type="button"
      class="btn btn-next w140"
      :disabled="showIndicator"
      @click="goToNextStep"
    ><span v-show="showIndicator"><i class="fa-regular fa-spinner fa-spin"></i></span> {{ nextButtonTitle }}</button>

    <div v-show="step === '3' || step === '4'" class="footer-empty-block"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { scrollToTop } from "../../helpers/scrollToTop";

export default {
  props: {
    onSaveCustomerStep: {
      type: Function,
      default: () => {}
    },
    onSaveAttendeesStep: {
      type: Function,
      default: () => {}
    },
    onSaveAgendaStep: {
      type: Function,
      default: () => {}
    },
    isAttendee: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isAttendee(newVal) {
      this.$emit('update:isAttendee', newVal);
    }
  },
  mounted() {
    this.coupon = null;
    this.$nextTick(() => {
      this.$refs.couponForm.reset();
    });
  },
  data() {
    return {
      code: null
    }
  },
  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "slug",
      "tickets",
      "settings",
      "step",
      "isFetching",
      "showIndicator",
      "donation",
      "errorMessage"
    ]),

    showNextButton() {
      return this.step === '1' || this.step === '1.1' || this.step === '2' || this.step === '2.1';
    },

    nextButtonTitle() {
      if (this.step === '1') {
        return 'Register';
      } else if (this.step === '1.1') {
        return 'Next';
      } else if (this.step === '2') {
        return 'Submit';
      } else if (this.step === '2.1') {
        return 'Next';
      }
    }
  },
  methods: {
    ...mapActions('basketStore', ['updateBasket', 'sendCoupon']),

    onHandleAddCoupon() {
      const data = {
        slug: this.slug,
        code: this.code,
        success: () => {
          this.$nextTick(() => {
            this.$refs.couponForm.reset();
          });
          this.code = null;
        },
        error: (err) => {
          if (err.errors) {
            this.$refs.couponForm.setErrors(err.errors);
          }
        }
      };

      this.$refs.couponForm.validate().then(success => {
        if (!success) {
          return
        }

        this.sendCoupon(data);
      });
    },

    goToNextStep() {
      if (this.step === '1') {
        const data = {
          tickets: this.tickets,
          confirm: true
        };

        this.updateBasket(data)
          .then((res) => {
            if (res?.response?.status === 422) {
              scrollToTop('.modal-body');
            } else {
              // go to next step if everything ok
              this.$store.dispatch('basketStore/changeStep', { type: "forward" });
            }
          })
          .finally(() => {
            this.$nextTick(() => {
              this.$refs.couponForm.reset();
            });
          });
      } else if (this.step === '1.1') {
        this.onSaveCustomerStep();
      } else if (this.step === '2') {
        this.onSaveAttendeesStep();
      } else if (this.step === '2.1') {
        this.onSaveAgendaStep();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-form {
  width: auto;
}
</style>
